

export const handleFilterChange = (e, filters, setFilters, setActiveFilters) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    setActiveFilters(newFilters);
};

export const handleSearchChange = (e, filters, setFilters, setActiveFilters, activeFilters) => {
    const { value } = e.target;
    setFilters({ ...filters, search: value });
    setActiveFilters({ ...activeFilters, search: value });
};

export const removeFilter = (filterType, filters, setFilters, setActiveFilters) => {
    const newFilters = { ...filters, [filterType]: '' };
    setFilters(newFilters);
    setActiveFilters(newFilters);
};

export const clearAllFilters = (setFilters, setActiveFilters) => {
    const newFilters = { status: '', sort: '', search: '' };
    setFilters(newFilters);
    setActiveFilters(newFilters);
};